export const ConfirmationStatus = {
    CONFIRMED : 'CONFIRMED',
    PENDING : 'PENDING',
    REJECTED : 'REJECTED',
    EXPIRED: 'EXPIRED'
}